import React from "react"
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Chip,
} from "@mui/material"
import { styled } from "@mui/material/styles"

import { titleize } from "../utils/stringUtils"

const SFAccordion = styled(Accordion)`
  button {
    font-family: Lato;
  }
`

export default class CollapsibleGenreBrowser extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
    }
  }

  handleToggle = () => {
    const { open } = this.state
    this.setState({ open: !open })
  }

  handleChipClick = (e) => {
    e.stopPropagation()
  }

  render() {
    const { mostPopularGenres, allGenreTags, genreToPathMap } = this.props
    const { open } = this.state
    const allGenreTagsExceptPopular = allGenreTags.filter(genre => !mostPopularGenres.includes(genre));
    return (
      <div className="CollapsibleGenreBrowser">
        <SFAccordion expanded={open} onChange={this.handleToggle}>
          <AccordionSummary
            expandIcon={<i className="fas fa-angle-down" aria-hidden="true"></i>}
          >
            <span className="side-text" aria-label="Collapsible genre browser">Top Genres</span>
            <div className="top-genre-list">
              {mostPopularGenres.map((genre) => {
                const tagURL = genreToPathMap[genre]
                return (
                  <Chip
                    label={titleize(genre)}
                    key={genre}
                    component="a"
                    href={tagURL}
                    clickable
                    onClick={this.handleChipClick}
                  />
                )
              })}
            </div>
            <span className="side-text browse-more-text" onClick={this.handleToggle}>{open ? "Collapse" : "Browse more"}</span>
          </AccordionSummary>
          <AccordionDetails>
            <div className="CollapsibleGenreBrowser__details">
              {allGenreTagsExceptPopular.map((genre) => {
                const tagURL = genreToPathMap[genre]
                return (
                  <Chip
                    label={titleize(genre)}
                    key={genre}
                    component="a"
                    href={tagURL}
                    clickable
                  />
                )
              })}
            </div>
          </AccordionDetails>
        </SFAccordion>
      </div>
    )
  }
}
